module.exports = __webpack_public_path__ + "img/afghanistan.1228a48a.png";